import { render, staticRenderFns } from "./sims.vue?vue&type=template&id=33815f9d&"
import script from "./sims.vue?vue&type=script&lang=js&"
export * from "./sims.vue?vue&type=script&lang=js&"
import style0 from "./sims.vue?vue&type=style&index=0&id=33815f9d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports